import React from 'react';
import {Link} from 'react-router';
import moment from 'moment';
import {get} from 'lodash';

class RowItemDanhSachKeHoachThanhTraDaPheDuyet extends React.Component {
  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <Link className='txt-underline txt-regular' to={`/thanh-tra/chi-tiet-ke-hoach-da-phe-duyet/${this.props.item.keHoachThanhTraId}`}>{`Kế hoạch ${this.props.item.loaiKeHoach.value=='KIEM_TRA' ? 'kiểm tra' : 'thanh tra'} năm ${get(this.props.item, 'namThanhTra')} ${get(this.props.item, 'keHoacThanhTraCuInfo') ? '(sửa đổi, bổ sung lần 1)' : ''}`}</Link>
        </td>
        <td className='list-items-table'>{get(this.props.item, 'quyetDinhPheDuyetKTTT')}</td>
        <td>{this.props.item.ngayRaQuyetDinh ? moment(this.props.item.ngayRaQuyetDinh).format('DD/MM/YYYY')  : ''}</td>
        <td>{get(this.props.item, 'soCuocThanhTra')}</td>
        <td>{get(this.props.item, 'trangThaiKeHoachThanhTraInfo.text')}</td>
      </tr>
    );
  }
}

export default RowItemDanhSachKeHoachThanhTraDaPheDuyet;



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/datatable/RowItemDanhSachKeHoachThanhTraDaPheDuyet.jsx